import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="w-full bg-gradient-to-b from-[#faf8f5] to-white py-12 md:py-20 lg:py-24" data-id="element-60">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl" data-id="element-61">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-62">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-6" data-id="element-63">
            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-[#1e3a8a] leading-tight" data-id="element-64">
              Cómo Generar tus Primeras Ventas{' '}
              <span className="relative inline-block" data-id="element-65">
                <span className="relative z-10 text-white px-3" data-id="element-66">
                  en 48 Horas
                </span>
                <span className="absolute inset-0 bg-[#f97316] -skew-y-1" data-id="element-67"></span>
              </span>
            </h1>
            <h2 className="text-xl md:text-2xl lg:text-3xl text-[#1e3a8a] font-medium leading-relaxed" data-id="element-68">
              (Sin Seguidores y Sin Complicaciones)
            </h2>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-69">
              El método de validación ultra-rápida para emprendedores latinos
              que necesitan resultados hoy mismo, no en meses.
            </p>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3,
            duration: 0.5
          }} className="space-y-4" data-id="element-70">
              <a href="#cta" className="inline-flex items-center gap-3 bg-[#f97316] hover:bg-[#ea580c] text-white font-bold text-lg md:text-xl px-8 py-5 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105" data-id="element-71">
                QUIERO MIS PRIMERAS VENTAS AHORA
                <ArrowRightIcon className="w-6 h-6" data-id="element-72" />
              </a>
              <p className="text-sm text-gray-600" data-id="element-73">
                ⚡ Acceso inmediato · Garantía de satisfacción
              </p>
            </motion.div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="relative" data-id="element-74">
            <img src="https://cdn.magicpatterns.com/uploads/qUxtogR1fAz6hitkQFmwa3/portada_final.png" alt="Primeras Ventas en 48 Horas - Producto" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-75" />
          </motion.div>
        </div>
      </div>
    </section>;
}